import { createTheme } from "@mui/material";
import cardOrListThemeValues from "./cardOrListThemeValues";
const cardOrListTheme = createTheme(cardOrListThemeValues);

export default cardOrListTheme;
